import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })
const whiteList = ['/agreement/privacy', '/agreement/user', '/agreement/pay', '/agreement/logoff', '/agreement/wallet', '/user/registry', '/user/registry', '/cms/banner', '/cms/titlebar', '/cms/video', '/guide/index', '/order/upload', '/order/flow', '/health'] // 白名单，直接进入
router.beforeEach((to, from, next) => {
  // start progress bar
  NProgress.start()
  if (whiteList.indexOf(to.path) !== -1) {
    return next()
  }
  let token = localStorage.getItem('token')
  if (to.query.accessToken) {
    token = to.query.accessToken
    localStorage.setItem('token', token)
  }
  if (from.path === '/') {
    from.meta.index = 0
  }

  if (to.params.inviteToken) {
    // 获取邀请人信息
    return next()
  } else if (!token) { // 未登录且没有token
    return next({ name: 'GuideIndex', replace: true })
  }

  const userInfo = store.getters.userInfo
  if (Object.keys(userInfo).length) { // 成功登录
    next()
  } else { // 未登录去获取用户信息
    if (token) {
      store.dispatch('user/getInfo').then(userInfo => {
      // 根据角色不同，去往不同页面
        return next({ name: 'Index', replace: true })
      }).catch(err => {
        console.log(err)
        store.dispatch('user/resetToken').then(() => {
          next({ name: 'GuideIndex', replace: true })
        })
      })
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
